import { Editor, Path, Node } from 'slate';
var removeEmptyParentNode = function removeEmptyParentNode(editor, pathRef) {
  var path = pathRef.current;
  var currentNode = Node.get(editor, path);
  var children = currentNode.children;
  while ((children.length === 0 || children.length === 1 && children[0].text === '') && currentNode.type) {
    Editor.removeNodes(editor, {
      at: path
    });
    path = Path.parent(path);
    currentNode = Node.get(editor, path);
    children = currentNode.children;
  }
  pathRef.unref();
};
var clearBlockFormat = function clearBlockFormat(editor) {
  // get selected block node, like the paragraphs in the blockquote;
  var nodes = Editor.nodes(editor, {
    match: 'block',
    voids: false
  });
  var nodesList = [];
  var pathRefs = Array.from(nodes, function (item) {
    nodesList.push(item);
    return Editor.pathRef(editor, item[1]);
  });
  var firstNode = nodesList[0],
    firstNodeRef = pathRefs[0];
  nodesList.shift();
  pathRefs.shift();
  // move first block to outest and set the block to paragraph
  while (firstNodeRef.current.length > 1) {
    Editor.liftNodes(editor, {
      at: firstNodeRef.current
    });
  }
  if (firstNode[0].type !== 'paragraph') {
    Editor.setNodes(editor, {
      type: 'paragraph',
      at: firstNodeRef.current,
      split: true
    });
  }
  nodesList.forEach(function (item, index) {
    var toPath = index === 0 ? Path.next(firstNodeRef.current) : Path.next(pathRefs[index - 1].current);
    var currentPath = pathRefs[index].current;
    if (currentPath.length > 1) {
      var parentPath = Path.parent(currentPath);
      var parentRef = Editor.pathRef(editor, parentPath);
      // move current node to outest
      Editor.moveNodes(editor, {
        at: currentPath,
        to: toPath
      });
      // remove empty parent node
      removeEmptyParentNode(editor, parentRef);
    }
    // set current block node to paragraph
    if (item[0].type !== 'paragraph') {
      Editor.setNodes(editor, {
        type: 'paragraph',
        at: currentPath,
        split: true
      });
    }
  });
  firstNodeRef.unref();
  pathRefs.forEach(function (ref) {
    return ref.unref();
  });
};
var clearMarkerFormat = function clearMarkerFormat(editor) {
  // clear all markers of selected texts;
  var textProperties = {
    BOLD: false,
    ITALIC: false,
    CODE: false
  };
  editor.exec({
    type: 'format_text',
    properties: textProperties
  });
};
export { clearBlockFormat, clearMarkerFormat };